import { useFlightContext } from "../../hooks/useFlightContext";
import { useStyles } from "./AllPrompts.web.styles";

export const useColumnStyle = (isHeroCard?: boolean, isMetaOsV2?: boolean) => {
  const styles = useStyles();
  const { isFlightActive } = useFlightContext();

  const cardColStyles = isFlightActive("isGoBoldPromptCardEnabled")
    ? styles.cardColV2
    : isHeroCard
      ? styles.metaOSV2ActionCard
      : isMetaOsV2
        ? styles.metaOsV2HomePage
        : styles.cardCol;

  return cardColStyles;
};
